import React, { useEffect, useState, useCallback, useRef } from "react";
import styled from "styled-components";
import { useAuth0 } from "@auth0/auth0-react";
import axiosInstance from "../../../../../appHelpers/axiosInstance";
import { SectionTitle, Loader, NoDataState } from "../../../../ui";
import { FleetSummaryCard } from "./FleetSummaryCard";
import { FleetTable } from "./FleetTable";

const REFRESH_MS = 60_000;

export const _EdgeFleetFC = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [summary, setSummary] = useState(null);
  const [systems, setSystems] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const timerRef = useRef(null);

  const fetchAll = useCallback(async () => {
    try {
      const token = await getAccessTokenSilently({
        audience: `${process.env.REACT_APP_AUTH0_EXPRESS_API}`,
      });
      const [sumRes, sysRes] = await Promise.all([
        axiosInstance({ url: "/edge/fleet/summary", headers: { authorization: `Bearer ${token}` } }),
        axiosInstance({ url: "/edge/fleet/systems", headers: { authorization: `Bearer ${token}` } }),
      ]);
      setSummary(sumRes?.data || null);
      setSystems(sysRes?.data || []);
      setError(null);
    } catch (e) {
      console.error("edge fleet fetch failed", e);
      setError("Failed to load edge fleet data.");
    } finally {
      setLoading(false);
    }
  }, [getAccessTokenSilently]);

  useEffect(() => {
    fetchAll();
    timerRef.current = setInterval(fetchAll, REFRESH_MS);
    return () => clearInterval(timerRef.current);
  }, [fetchAll]);

  return (
    <Wrap>
      <SectionTitle
        title="Edge Fleet"
        subtitle="mmb-edge boxes reporting via stats.edge_heartbeats · refreshes every 60s"
      />

      {loading && !systems ? (
        <Center><Loader size="large" message="Loading fleet…" /></Center>
      ) : error ? (
        <NoDataState
          title="Error Loading Edge Fleet"
          description={error}
          showRetry
          onRetry={fetchAll}
        />
      ) : (
        <>
          <FleetSummaryCard summary={summary} loading={loading} />
          <FleetTable rows={systems} loading={loading} />
        </>
      )}
    </Wrap>
  );
};

const Wrap = styled.div`
  padding: 2rem;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
`;

const Center = styled.div`
  display: flex; justify-content: center; align-items: center; min-height: 300px;
`;
